import LabelProvider from "core/components/label/LabelProvider";
import courseLabels from "common/entities/courseWrapper/labels";

export default LabelProvider.create({
	...courseLabels.getData(),
	FeaturedCoursesEmpty: {
		k: "featured.empty.title",
		v: "No Featured Courses Available"
	},

	DescriptionEmpty: {
		k: "featured.empty.description",
        v: ""
	}
});



// WEBPACK FOOTER //
// ./src/panels/featuredItems/FeaturedItems.labels.ts